import React, { Component } from 'react';
import { Classes, Intent, Button, RadioGroup, Radio } from '@blueprintjs/core';
import { defineMessages, injectIntl } from 'react-intl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import c from 'classnames';

import withRouter from 'app/withRouter';
import { forceMutate, ingestDocument } from 'actions';
import { showErrorToast } from 'app/toast';
import FormDialog from 'dialogs/common/FormDialog';
import axios from 'axios';

const messages = defineMessages({
  title: {
    id: 'document.folder.title',
    defaultMessage: 'New folder',
  },
  save: {
    id: 'document.folder.save',
    defaultMessage: 'Create',
  },
  untitled: {
    id: 'document.folder.untitled',
    defaultMessage: 'Folder title',
  },
  error: {
    id: 'document.folder.error',
    defaultMessage: 'There was an error creating the folder.',
  },
});

export class DocumentFileDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      blocking: false,
      selectedType: 'word', 
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeTitle = this.onChangeTitle.bind(this);
  }

  onChangeTitle(event) {
    this.setState({ title: event.target.value });
  }

  onChangeType = (event) => {
    this.setState({ selectedType: event.target.value });
  };

  async onSubmit() {
    const { collection, toggleDialog, isOpen } = this.props;
    const { title, selectedType } = this.state;
    this.setState({ blocking: true });
    try {
      if (title === '') {
        showErrorToast('กรุณากรอกชื่อเอกสาร');
        this.setState({ blocking: false });
        return;
      }

      const response = await axios.post(`/api/2/documents/onlyoffice/create/${collection.id}`, {
        document_type: selectedType,
        file_name: title,
      });

      if (response.status !== 201) {
        showErrorToast('เกิดข้อผิดพลาดในการสร้างเอกสาร');
        this.setState({ blocking: false });
        return;
      }

      const contentHash = response.data.content_hash;

      // add sleep 1 seconds
      await new Promise((resolve) => setTimeout(resolve, 1000));

      const link = document.createElement('a');
      link.href = `/onlyoffice/${contentHash}`;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      this.setState({ blocking: false });

      if (isOpen) {
        toggleDialog();
      }

      this.props.onClose?.();
    } catch (e) {
      showErrorToast('เกิดข้อผิดพลาดในการสร้างเอกสาร');
      this.setState({ blocking: false });
    }
  }

  render() {
    const { intl, toggleDialog, isOpen } = this.props;
    const { title, blocking } = this.state;

    return (
      <FormDialog
        processing={blocking}
        icon="plus"
        className="DocumentFileDialog"
        isOpen={isOpen}
        onSubmit={this.onSubmit}
        title="เอกสารใหม่"
        onClose={toggleDialog}
      >
        <div className={Classes.DIALOG_BODY}>
          <div className={Classes.FORM_GROUP}>
            <div
              className={c(Classes.INPUT_GROUP, Classes.LARGE, Classes.FILL)}
            >
              <input
                id="label"
                type="text"
                className={Classes.INPUT}
                autoComplete="off"
                placeholder="ชื่อเอกสาร"
                onChange={this.onChangeTitle}
                value={title}
              />
            </div>
          </div>

          {/* Add Radio Button Group */}
          <div className={Classes.FORM_GROUP}>
            <label className={Classes.LABEL}>ประเภทเอกสาร</label>
            <RadioGroup
              onChange={this.onChangeType}
              selectedValue={this.state.selectedType}
              inline
            >
              <Radio label="Word" value="word" />
              <Radio label="Cell" value="cell" />
              <Radio label="Slide" value="slide" />
              <Radio label="PDF" value="pdf" />
              <Radio label="Text" value="text" />
            </RadioGroup>
          </div>
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button
              type="submit"
              disabled={blocking}
              intent={Intent.PRIMARY}
              text={intl.formatMessage(messages.save)}
            />
          </div>
        </div>
      </FormDialog>
    );
  }
}
const mapDispatchToProps = { forceMutate, ingestDocument };
export default compose(
  withRouter,
  connect(null, mapDispatchToProps),
  injectIntl
)(DocumentFileDialog);
